<template>
  <v-row no-gutters justify="start" class="fill-height pa-2" align="stretch">
    <v-col cols="12" md="12" sm="12">
      <div v-if="loadingBasket">
        <v-progress-linear
          color="blue darken-2"
          indeterminate
        ></v-progress-linear>
        <v-card-title>Loading Baskets</v-card-title>
      </div>
      <div v-else-if="trolly != false">
        <v-card-actions>
          <h3>Current Basket</h3>
          <v-spacer />
          <v-btn
            v-if="$store.getters.retrieveHasMultipleTrollys"
            outlined
            color="blue darken-2"
            :to="{ name: 'OrdersBasketSelection' }"
          >
            <v-icon left>shopping_cart</v-icon>Change Basket
          </v-btn>
        </v-card-actions>

        <v-card-text class="pa-2">
          {{ DelColLabel }} order for
          <b>{{ trolly.order_date_display }}</b></v-card-text
        >
        <v-card-subtitle class="pa-2">
          <div>
            No. Items:
            <b>{{ trolly.totalItems }}</b>
          </div>
          <div>
            Total Value:
            <b v-if="retrieveShowPrices">£{{ trolly.totalValue }}</b>
          </div>
        </v-card-subtitle>
      </div>
      <div v-else-if="$store.getters.retrieveHasMultipleTrollys">
        <v-card-title>Multiple Baskets Open</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="$store.getters.retrieveHasMultipleTrollys"
            outlined
            color="blue darken-2"
            :to="{ name: 'OrdersBasketSelection' }"
          >
            <v-icon left>shopping_cart</v-icon>Change Basket
          </v-btn>
        </v-card-actions>
      </div>
      <div v-else>
        <v-card-title>No Baskets Open</v-card-title>
      </div>
    </v-col>

    <v-col cols="12" md="12" sm="12" align-self="end">
      <v-card-actions v-if="trolly != false" class="fill-height">
        <v-btn text color="blue darken-2" :to="{ name: 'OrdersSearch' }"
          >Continue Shopping</v-btn
        >
        <v-spacer />
        <v-btn text color="blue darken-2" :to="{ name: 'OrdersBasket' }"
          >View Basket</v-btn
        >
      </v-card-actions>
      <v-card-actions v-else-if="!$store.getters.retrieveHasMultipleTrollys">
        <v-spacer />
        <v-btn text color="blue darken-2" :to="{ name: 'OrdersCreate' }"
          >Start Shopping</v-btn
        >
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BasketOverview",

  props: {
    loadingBasket: Boolean,
  },

  data: () => ({
    // loadingBasket: true,
  }),

  computed: {

    ...mapGetters(['retrieveShowPrices']),
    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },

    DelColLabel() {
      let label = "Delivery";

      if (this.$store.getters.retrieveIsCncCustomer) {
        label = "Collection ";
      }

      return label;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>